<div class="dfid-shell">
    <div class="dfid-shell-inner">
        <div class="sidenav-content" [class.single-pane]="!integrationSelected">

            <!-- LEFT: Run history -->
            <section class="panel panel--history" *ngIf="integrationSelected">
                <div class="panel-header">
                    <div class="panel-title">Run History</div>
                </div>

                <div class="panel-body panel-body--scroll">
                    <div class="panel-inner-outline">
                        <app-integration-history class="run-history"></app-integration-history>
                    </div>
                </div>
            </section>

            <!-- RIGHT: Configure & Run -->
            <section class="panel panel--action">
                <div class="panel-header">
                    <div class="panel-title">Configure &amp; Run</div>
                </div>

                <div class="panel-body panel-body--fill">
                    <mat-tab-group mat-stretch-tabs="false" class="process-options-container">
                        <mat-tab *ngFor="let integrationAction of integrationActions | async">
                            <ng-template matTabLabel>
                                <span>{{ getActionDisplayName(integrationAction) }}</span>
                            </ng-template>

                            <div class="tab-fill">
                                <div class="action-header">
                                    <div class="action-title-top">
                                        <div class="action-label">{{ getActionDisplayName(integrationAction) }}</div>
                                        <div class="action-subtitle">
                                            Configure parameters, then run the action.
                                        </div>
                                    </div>
                                </div>

                                <!-- Params area -->
                                <div class="action-scroll">
                                    <div class="panel-inner-outline">
                                        <div class="config-section">
                                            <div class="config-section-title">Parameters</div>

                                            <div class="params-list">
                                                <ng-container *ngFor="let param of integrationAction.parameters">
                                                    <div *ngIf="param.prompt === true" class="param-row"
                                                        [class.param-row--checkbox]="param.dataType=='4'">

                                                        <div class="param-label" *ngIf="param.dataType!='4'">{{
                                                            param.alias }}</div>

                                                        <div class="param-control">
                                                            <mat-form-field *ngIf="param.dataType=='0'" color="accent"
                                                                appearance="fill">
                                                                <mat-label>{{param.alias}}</mat-label>
                                                                <input matInput [(ngModel)]="param.defaultValue" />
                                                            </mat-form-field>

                                                            <mat-form-field *ngIf="param.dataType=='1'" color="accent"
                                                                appearance="fill">
                                                                <mat-label>{{param.alias}}</mat-label>
                                                                <input matInput [(ngModel)]="param.defaultValue" />
                                                            </mat-form-field>

                                                            <mat-form-field *ngIf="param.dataType=='2'" color="accent"
                                                                appearance="fill">
                                                                <mat-label>{{param.alias}}</mat-label>
                                                                <input matInput [(ngModel)]="param.defaultValue"
                                                                    type="number" (keypress)="onlyNumberKey($event)" />
                                                            </mat-form-field>

                                                            <mat-form-field *ngIf="param.dataType=='3'" color="accent"
                                                                appearance="fill">
                                                                <mat-label>{{param.alias}}</mat-label>
                                                                <input matInput [(ngModel)]="param.defaultValue"
                                                                    type="number" />
                                                            </mat-form-field>

                                                            <mat-checkbox *ngIf="param.dataType=='4'" class="checkbox"
                                                                [(ngModel)]="param.defaultValue">
                                                                {{ param.alias }}
                                                            </mat-checkbox>

                                                            <mat-form-field *ngIf="param.dataType=='5'" color="accent"
                                                                appearance="fill">
                                                                <mat-label>mm/dd/yyyy</mat-label>
                                                                <input matInput [matDatepicker]="datePicker"
                                                                    [(ngModel)]="param.defaultValue"
                                                                    [ngModelOptions]="{ standalone: true }" />
                                                                <mat-datepicker-toggle matSuffix
                                                                    [for]="datePicker"></mat-datepicker-toggle>
                                                                <mat-datepicker #datePicker></mat-datepicker>
                                                            </mat-form-field>

                                                            <mat-form-field *ngIf="param.dataType=='Spinner'"
                                                                color="accent" appearance="fill">
                                                                <mat-label>mm/dd/yyyy</mat-label>
                                                                <input matInput [matDatepicker]="spinnerPicker"
                                                                    [(ngModel)]="param.defaultValue"
                                                                    [ngModelOptions]="{ standalone: true }" />
                                                                <mat-datepicker-toggle matSuffix
                                                                    [for]="spinnerPicker"></mat-datepicker-toggle>
                                                                <mat-datepicker #spinnerPicker></mat-datepicker>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Footer -->
                                <div class="action-footer">
                                    <div class="debug-toggle" *ngIf="localHostAccess && notProd">
                                        <label class="localhost-label">Debug Localhost?</label>
                                        <mat-checkbox [(ngModel)]="runOnLocalHost" (change)="toggleLocalHost($event)">
                                            {{strings["disable"]}}
                                        </mat-checkbox>
                                    </div>

                                    <div class="process-button-container">
                                        <button *ngIf="!runOnLocalHost" class="process-button" mat-raised-button
                                            color="primary" [disabled]="actionDisabled"
                                            (click)="runIntegrationAction(integrationAction.name, integrationAction.parameters)">
                                            {{strings["process"]}}
                                        </button>

                                        <button *ngIf="runOnLocalHost" class="debug-button" mat-raised-button
                                            color="accent" [disabled]="actionDisabled"
                                            (click)="runDebugAction(integrationAction.name, integrationAction.parameters)">
                                            {{strings["debug"]}}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </section>

        </div>
    </div>
</div>